import React from 'react';
import Chart from "chart.js"
import EpflLoader from './../helper/EpflLoader'
import './../helper/dropdown.css'
import './chartMarkers.css'
import { Link } from 'react-router-dom';
var uniqueID = 0;
const getUniqueID = () => {
    uniqueID = uniqueID + 1;
    return uniqueID;
}
const modalities = ["AS","DH","BP","2D"];
const markerStyles = ["circle","rect","triangle","crossRot"]
const datasets = ["MT1","MT2","MT3","MT4","ER1","ER2"];
const colorTable = ["#96c625","#e70012","#4251a2","#f3ab19","#34beef","#b27bb4"]

class Leaderboard extends React.Component{

    constructor(props){
        super(props)
        this.state = {headers:[],
                    data:[],
                    filteredHeaders:[],
                    filteredData:[],
                    sortAscend:true,
                    response:0,
                    isLoading:false,
                    xAxes:5,
                    yAxes:6}
        this.chart = null
        this.fetchLeaderboard.bind(this)
        this.filterTable.bind(this)
        this.sortTable.bind(this)
        this.isNumeric.bind(this)
        this.getCSV.bind(this)
        this.updateLeaderboardChart.bind(this)
        this.getDatasetForChart.bind(this)
        
    }

    getDatasetForChart(data) {
        return data.map(row => 
            { let id = datasets.findIndex( d => row[1].includes(d));
                
                return {
                software: row[0],
                challengeDataset: row[1],
                modality: row[2],
                xlabel:this.state.filteredHeaders[this.state.xAxes],
                ylabel:this.state.filteredHeaders[this.state.yAxes],
                data: [{x:row[this.state.xAxes],y:row[this.state.yAxes]}],
                borderColor:colorTable[id],
                backgroundColor : colorTable[id],
                pointStyle:markerStyles[modalities.findIndex(m => row[2].includes(m))]
                }
            })
    }
    

    updateLeaderboardChart(data) {
        
            let ctx = document.getElementById("canvasLeaderboard").getContext("2d")
            if (this.chart == null){
                Chart.defaults.global.defaultFontSize = 16
                Chart.defaults.global.elements.point.radius = 6
                Chart.defaults.global.elements.point.hoverRadius = 8
                Chart.defaults.global.elements.point.borderWidth = 3

                this.chart = new Chart(ctx,{
                    type: 'scatter',
                    data: { 
                        datasets: this.getDatasetForChart(data)
                    },
                options:{
                    legend:{display:false},
                    tooltips:{enabled:true,
                        callbacks : { 
                            beforeLabel : function(tooltipItem, data) {
                                return 'Software ' + ': ' + data.datasets[tooltipItem.datasetIndex].software;
                            },
                            label : function(tooltipItem, data) {
                                return data.datasets[tooltipItem.datasetIndex].challengeDataset + ' / ' + 
                                    data.datasets[tooltipItem.datasetIndex].modality
                            },
                            afterLabel: function(tooltipItem,data){
                                // round data to 2 digitsfor display
                                return  data.datasets[tooltipItem.datasetIndex].xlabel + ': ' + 
                                        Math.round(100*data.datasets[tooltipItem.datasetIndex].data[0].x)/100 + ';' + 
                                        data.datasets[tooltipItem.datasetIndex].ylabel  + ': ' + 
                                        Math.round(100*data.datasets[tooltipItem.datasetIndex].data[0].y)/100

                            }
                        }
        
                    },
                    tooltipTemplate : "<%=label%>",
                    scales :{
                    xAxes: [{
                        scaleLabel: {
                        display: true,
                        labelString: this.state.filteredHeaders[this.state.xAxes]
                            }
                        
                        }],
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: this.state.filteredHeaders[this.state.yAxes]
                            }
                        
                        }]
                    }
                    }
                })
            }
            else { // chart already created
                // update data and axes
                this.chart.data.datasets = this.getDatasetForChart(data)
                this.chart.options.scales.xAxes = [{
                    scaleLabel: {
                    display: true,
                    labelString: this.state.filteredHeaders[this.state.xAxes]
                        }
                    
                    }]
                this.chart.options.scales.yAxes = [{
                    scaleLabel: {
                        display: true,
                        labelString: this.state.filteredHeaders[this.state.yAxes]
                        }
                    }]
                this.chart.update();
            }
    }

    getCSV(){
        // convert the leaderboard to csv string
        let csvContent = "" 
        this.state.filteredHeaders.forEach(e =>
            csvContent += e + ",")
        csvContent +=  "\n"
        this.state.filteredData.forEach(row => {
            row.forEach(e =>
                csvContent += e + ",")
            return csvContent += "\n"
            })
        return [csvContent]
    }

    // the leaderboard file has to be fetched from the server since we do not want to include it in the build
    fetchLeaderboard(){
        const fetchPath = "/api/getLeaderboard"
        this.setState({isLoading:true,response:0})
        fetch(fetchPath,
        {
            method: 'get',
            headers: {
                "Accept": "application/text"
            },
            mode: 'same-origin'
        }).then (response => {
            if (response.ok) {
                response.json().then(r => {
                    // response contains two lists: headers and data
                    
                    this.setState({headers:r["headers"],
                                    data:r["data"],
                                    response:1,
                                    isLoading:false})
                    this.filterTable();
                })
            } else {
                this.setState({response:-1})
            }
        })
    }
    
    componentDidMount(){
        this.fetchLeaderboard()
    }

    isNumeric(str) {
        if (typeof str != "string") return false // we only process strings!  
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
               !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
      }

    sortTable(index){
        // sort software object list based on input key and update filteredList
        let sortedData = this.state.filteredData;
        
        // look for the first non empty entry of the list
        let i = sortedData.findIndex(e => e[index] !== "-")

        // is the datatype numeric
        let isNum = this.isNumeric(sortedData[i][index]);
        

        sortedData = sortedData.sort((a,b) => {
            
            if (a[index] === "-" && isNum)
                return -1
            else if (b[index] === "-" && isNum)
                return 1
            else {
                let cp = isNum ? parseFloat(a[index])>parseFloat(b[index]) : a[index].toUpperCase()>b[index].toUpperCase()
                if (this.state.sortAscend === true)
                    return cp
                else
                    return !cp
            }
        })

        this.setState({filteredData:sortedData,sortAscend:!this.state.sortAscend})
        this.updateLeaderboardChart(sortedData)
    }

    filterTable(){
        var filteredData = this.state.data;
        var filteredHeaders = this.state.headers;

        // check if at least one modality is checked
        var atLeastOneModalityChecked = false
        modalities.forEach(m => {
            if (document.getElementById(m).checked === true)
                atLeastOneModalityChecked = true
        })
        // filter per modalities if at least one is checked
        if (atLeastOneModalityChecked)
            modalities.forEach(m => {
                        // third column is for modalities
                        // check if e[2] contains the modality m
                if (document.getElementById(m).checked === false) 
                    filteredData = filteredData.filter( e => {
                        return !(e[2].includes(m))
                    })
                
            })
        // check if at least one dataset is checked
        var atLeastOneDatasetChecked = false
        datasets.forEach(m => {
            if (document.getElementById(m).checked === true)
                atLeastOneDatasetChecked = true
        })
        // filter per modalities if at least one is checked
        if (atLeastOneDatasetChecked)
            datasets.forEach(m => {
                        // third column is for modalities
                        // check if e[1] contains the modality m
                if (document.getElementById(m).checked === false) 
                    filteredData = filteredData.filter( e => {
                        return !(e[1].includes(m))
                    })
                
            })
            
        filteredData = filteredData.map( e => {
            e.splice(16,30); return e})
        filteredHeaders.splice(16,30)

        // set state and update display
        this.setState({filteredData:filteredData,
                       filteredHeaders:filteredHeaders})

        this.updateLeaderboardChart(filteredData)
    }

    

    render(){
        const legend = (i) => {
            return {width:"10px",height:"10px",borderRadius:"50%",position:"relative",top:"8px",justifyContent:"center", marginRight:"4px",
                    backgroundColor:colorTable[i]}
        }
        return (
            <div>
                <h2>Challenge leaderboard overview</h2>
                <div style={{display:"flex"}}>
                    <div style={{display:"block",maxWidth:"900px",maxHeight:"700px"}}>
                        <div style={{display:"flex",justifyContent:"space-between"}}>
                            <div style={{display:"flex",justifyContent:"center",marginLeft:"25px",marginRight:"25px"}}>{datasets.map((d,i) => <span style={{display:"flex",marginRight:"10px"}}><div style={legend(i)}></div>{d}</span>)} </div> 
                            <div style={{display:"flex",justifyContent:"center",marginLeft:"25px",marginRight:"25px"}}>{modalities.map((m,i) => <span style={{display:"flex",marginRight:"10px"}}>
                                {markerStyles[i] === "crossRot" ?
                                    <div className={markerStyles[i]}> <div style={{marginRight:"4px",color:"black"}}>x</div> <div>{m}</div>
                                    </div>
                                    :<div style={{display:"flex"}}><div className={markerStyles[i]}></div>{m}</div>}</span>)}
                            </div> 
                        </div>
                        <canvas id="canvasLeaderboard" width="900" height="500"></canvas>
                    </div>
                    <div style={{width:"20px"}}></div>
                        
                    <div style={{width:"300px"}}> 
                    
                        <span className="form-group" >
                            <label>Select Y axis data</label>
                            <select id="yaxis_select" className="custom-select" 
                                onChange={() => {this.state.yAxes = parseFloat(document.getElementById("yaxis_select").value) + 4; // +4 offset first two collumns of data
                                document.getElementById("yaxis_select").value = (this.state.yAxes-4).toString()
                                    this.updateLeaderboardChart(this.state.filteredData)}}>
                                {this.state.headers.slice(4).map((h,i) => {
                                    return (<option value={i} selected={(this.state.yAxes-4)===i} key={i}>{h}</option>)
                                })
                                }
                            </select>
                        </span>
                        <span className="form-group">
                            <label>Select X axis data</label>
                            <select id="xaxis_select" className="custom-select" 
                                onChange={() => {this.state.xAxes = parseFloat(document.getElementById("xaxis_select").value) + 4;
                                this.updateLeaderboardChart(this.state.filteredData)}}>
                                {this.state.headers.slice(4).map((h,i) => {
                                    return (<option value={i} selected={(this.state.xAxes-4)===i} key={i}>{h}</option>)
                                })
                                }
                            </select>
                        </span>
                    </div>
                </div>
                <hr></hr>


                <h2>Challenge leaderboard table</h2>
                {this.state.isLoading && <EpflLoader/>}
                {!this.state.isLoading &&
                <div>
                    <div className="controlHead">
                        <span className="dropdown">
                                <button className="btn btn-primary" style={{margin: "5px"}}> Filter per modalities</button>
                                <span className="dropdown-content">
                                    <div style={{display:"block",gridTemplateColumns: "auto auto auto",
                                    backgroundColor:"#f9f9f9",padding:"10px"}}>
                                    {modalities.map(m => 
                                        <div className="custom-control custom-checkbox" key={m}>
                                        <input type="checkbox" className="custom-control-input" id={m} name={m}
                                        onChange={() => {this.filterTable()}}/> 
                                        <label className="custom-control-label" htmlFor={m}> {m}</label>
                                        </div>)
                                    }
                                    </div>
                                </span>
                        </span>
                        <span className="dropdown">
                                <button className="btn btn-primary" style={{margin: "5px"}}> Filter per datasets</button>
                                <span className="dropdown-content">
                                    <div style={{display:"block",gridTemplateColumns: "auto auto auto",
                                    backgroundColor:"#f9f9f9",padding:"10px"}}>
                                    {datasets.map( m => 
                                        <div className="custom-control custom-checkbox" key={m}>
                                        <input type="checkbox" className="custom-control-input" id={m} name={m}
                                        onChange={() => this.filterTable()}/> 
                                        <label className="custom-control-label" htmlFor={m}> {m}</label>
                                        </div>)
                                    }
                                    </div>
                                </span>
                        </span>
                        <span>
                        <button className="btn btn-primary" style={{margin: "5px"}}
                            onClick={ () => {
                                const element = document.createElement("a");
                                const file = new Blob(this.getCSV(),    
                                            {type: 'text/plain;charset=utf-8'});
                                element.href = URL.createObjectURL(file);
                                element.download = "leaderboard.csv";
                                document.body.appendChild(element);
                                element.click();
                            }
                            }>
                            Download leaderboard (.csv){' '}
                            <svg className="icon" aria-hidden="true">
                                <use xlinkHref="#icon-upload"></use>
                            </svg>
                        </button>
                    </span> 
                    </div>
                    <div className="tablesaw-bar tablesaw-mode-stack" style={{margin: "5px"}}/>
                    {/*<table id="tablesaw2" className="table table-sortable tablesaw-stack tablesaw-sortable" data-tablesaw-sortable="true">*/}
                    <table id="tablesaw2" className="table table-sortable tablesaw-stack tablesaw-sortable">
                        <thead>
                            <tr>
                                {this.state["filteredHeaders"].map((e,index) => 
                                <th className="hoverRed" data-tablesaw-sortable-col key={getUniqueID()}
                                    dangerouslySetInnerHTML={{__html:e}}
                                    onClick={() => this.sortTable(index)}>{}
                                    </th>)
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {this.state["filteredData"].map(e=> <tr>
                                {e.map((val,i) =>
                                 <td key={getUniqueID()}>
                                    {this.state.filteredHeaders[i] === 'Software' ?
                                       <Link to={'/ChallengeSoftwareInfo?name='+val}>{val}</Link> : 
                                       (this.isNumeric(val) ? Math.round(parseFloat(val)*100)/100 : val)
                                    }
                                    </td>
                                )}
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                }
            </div>
        )
    }
}

export default Leaderboard;